// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"696":"45dbaff5","964":"76387427"}[chunkId] + ".chunk.css";
};